import axios from "axios";
import toast from "react-hot-toast";

const BASE_URL = process.env.REACT_APP_API_BASE_URL;

// Action Types
export const FETCH_SURVEY_OFFICERS_REQUEST = "FETCH_SURVEY_OFFICERS_REQUEST";
export const FETCH_SURVEY_OFFICERS_SUCCESS = "FETCH_SURVEY_OFFICERS_SUCCESS";
export const FETCH_SURVEY_OFFICERS_FAILURE = "FETCH_SURVEY_OFFICERS_FAILURE";

export const CREATE_SURVEY_OFFICER_REQUEST = "CREATE_SURVEY_OFFICER_REQUEST";
export const CREATE_SURVEY_OFFICER_SUCCESS = "CREATE_SURVEY_OFFICER_SUCCESS";
export const CREATE_SURVEY_OFFICER_FAILURE = "CREATE_SURVEY_OFFICER_FAILURE";

export const UPLOAD_SURVEY_OFFICERS_REQUEST = "UPLOAD_SURVEY_OFFICERS_REQUEST";
export const UPLOAD_SURVEY_OFFICERS_SUCCESS = "UPLOAD_SURVEY_OFFICERS_SUCCESS";
export const UPLOAD_SURVEY_OFFICERS_FAILURE = "UPLOAD_SURVEY_OFFICERS_FAILURE";

export const DOWNLOAD_TEMPLATE_REQUEST = "DOWNLOAD_TEMPLATE_REQUEST";
export const DOWNLOAD_TEMPLATE_SUCCESS = "DOWNLOAD_TEMPLATE_SUCCESS";
export const DOWNLOAD_TEMPLATE_FAILURE = "DOWNLOAD_TEMPLATE_FAILURE";

export const UPDATE_SURVEY_OFFICER_REQUEST = "UPDATE_SURVEY_OFFICER_REQUEST";
export const UPDATE_SURVEY_OFFICER_SUCCESS = "UPDATE_SURVEY_OFFICER_SUCCESS";
export const UPDATE_SURVEY_OFFICER_FAILURE = "UPDATE_SURVEY_OFFICER_FAILURE";

export const SET_UPLOAD_PROGRESS = "SET_UPLOAD_PROGRESS";

export const fetchSurveyOfficers =
  (page = 1, limit = 10, filters = {}) =>
  async (dispatch) => {
    dispatch({ type: FETCH_SURVEY_OFFICERS_REQUEST });
    const token = localStorage.getItem("token");

    try {
      // Build query string with filters
      let queryParams = `?page=${page}&limit=${limit}`;

      if (filters.district_id) {
        queryParams += `&district_id=${filters.district_id}`;
      }

      if (filters.municipality_id) {
        queryParams += `&municipality_id=${filters.municipality_id}`;
      }

      const response = await axios.get(
        `${BASE_URL}/v1/api/surveyOfficers${queryParams}`,
        {
          headers: { authorization: token },
        },
      );

      if (response.data.meta.status) {
        dispatch({
          type: FETCH_SURVEY_OFFICERS_SUCCESS,
          payload: {
            data: response.data.data,
            pagination: response.data.meta.pagination,
          },
        });
        return response.data;
      } else {
        dispatch({ type: FETCH_SURVEY_OFFICERS_FAILURE });
        throw new Error(response.data.meta.message);
      }
    } catch (error) {
      dispatch({ type: FETCH_SURVEY_OFFICERS_FAILURE });
      toast.error(
        error.response?.data?.meta?.message ||
          "Failed to fetch survey officers",
      );
      throw error;
    }
  };

// Create Survey Officer
export const createSurveyOfficer = (officerData) => async (dispatch) => {
  dispatch({ type: CREATE_SURVEY_OFFICER_REQUEST });

  const token = localStorage.getItem("token");

  try {
    const response = await axios.post(
      `${BASE_URL}/v1/api/createSurveyOfficer`,
      officerData,
      {
        headers: { authorization: token },
      },
    );

    if (response.data.meta.status) {
      dispatch({
        type: CREATE_SURVEY_OFFICER_SUCCESS,
        payload: response.data.data,
      });
      toast.success(
        response.data.meta.message || "Survey Officer created successfully!",
      );
      return response.data;
    } else {
      dispatch({ type: CREATE_SURVEY_OFFICER_FAILURE });
      throw new Error(response.data.meta.message);
    }
  } catch (error) {
    dispatch({ type: CREATE_SURVEY_OFFICER_FAILURE });
    toast.error(
      error.response?.data?.meta?.message || "Failed to create survey officer",
    );
    throw error;
  }
};

// Upload Survey Officers (Bulk)
export const uploadSurveyOfficers = (formData) => async (dispatch) => {
  dispatch({ type: UPLOAD_SURVEY_OFFICERS_REQUEST });

  const token = localStorage.getItem("token");

  try {
    const response = await axios.post(
      `${BASE_URL}/v1/api/uploadSurveyOfficers`,
      formData,
      {
        headers: {
          "Content-Type": "multipart/form-data",
          authorization: token,
        },
        onUploadProgress: (progressEvent) => {
          const percentCompleted = Math.round(
            (progressEvent.loaded * 100) / progressEvent.total,
          );
          dispatch({ type: SET_UPLOAD_PROGRESS, payload: percentCompleted });
        },
      },
    );

    if (response.data.meta.status) {
      dispatch({
        type: UPLOAD_SURVEY_OFFICERS_SUCCESS,
        payload: response.data.data,
      });
      dispatch({ type: SET_UPLOAD_PROGRESS, payload: 0 });
      toast.success(
        response.data.meta.message || "Survey Officers uploaded successfully!",
      );
      return response.data;
    } else {
      dispatch({ type: UPLOAD_SURVEY_OFFICERS_FAILURE });
      throw new Error(response.data.meta.message);
    }
  } catch (error) {
    dispatch({ type: UPLOAD_SURVEY_OFFICERS_FAILURE });
    dispatch({ type: SET_UPLOAD_PROGRESS, payload: 0 });
    toast.error(
      error.response?.data?.meta?.message || "Failed to upload survey officers",
    );
    throw error;
  }
};

// download template

export const downloadTemplate = () => async (dispatch) => {
  dispatch({ type: DOWNLOAD_TEMPLATE_REQUEST });

  try {
    const s3Url =
      "https://e-attendance-ebs.s3.ap-south-1.amazonaws.com/uploads/2772da30-13d5-42c3-a0e5-375eb9621639";

    const link = document.createElement("a");
    link.href = s3Url;
    link.download = "survey_officer_template.xlsx";
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);

    dispatch({ type: DOWNLOAD_TEMPLATE_SUCCESS });
    toast.success("Template downloading...");
  } catch (error) {
    dispatch({ type: DOWNLOAD_TEMPLATE_FAILURE });
    toast.error("Failed to download template. Please try again.");
    throw error;
  }
};

// update SurveyOfficer
// update SurveyOfficer
export const updateSurveyOfficer = (id, officerData) => async (dispatch) => {
  dispatch({ type: UPDATE_SURVEY_OFFICER_REQUEST });

  const token = localStorage.getItem("token");

  try {
    const response = await axios.put(
      `${BASE_URL}/v1/api/updateSurveyOfficer/${id}`,
      officerData,
      {
        headers: { authorization: token },
      },
    );

    if (response.data.meta.status) {
      dispatch({
        type: UPDATE_SURVEY_OFFICER_SUCCESS,
        payload: response.data.data,
      });
      toast.success(
        response.data.meta.message || "Survey Officer updated successfully!",
      );
      return response.data;
    } else {
      dispatch({ type: UPDATE_SURVEY_OFFICER_FAILURE });
      throw new Error(response.data.meta.message);
    }
  } catch (error) {
    dispatch({ type: UPDATE_SURVEY_OFFICER_FAILURE });
    let errorMessage = "Failed to update survey officer";

    if (error.response?.data?.meta?.message) {
      errorMessage = error.response.data.meta.message;
    } else if (error.response?.data?.message) {
      errorMessage = error.response.data.message;
    } else if (error.message) {
      errorMessage = error.message;
    }

    toast.error(errorMessage);
    throw error;
  }
};
